import React from 'react';
import { DataEditor } from '~/components/DataEditor';
import { Documentation } from '~/components/Documentation';
import { LivePreview } from '~/components/LivePreview';
import { Profile } from '~/components/Profile';
import { TemplateEditor } from '~/components/TemplateEditor';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '~/components/ui/tabs';

export const PdfEditor: React.FC = () => {
  return (
    <div className='w-screen h-screen flex p-4 gap-4 overflow-hidden '>
      <div className='flex-2 flex flex-col gap-4 overflow-hidden'>
        <Tabs defaultValue='template' className='flex-1 '>
          <TabsList>
            <TabsTrigger value='template'>template.json</TabsTrigger>
            <TabsTrigger value='data'>data.json</TabsTrigger>
          </TabsList>
          <TabsContent value='template' className='flex-1 flex'>
            <TemplateEditor />
          </TabsContent>
          <TabsContent value='data' className='flex-1 flex'>
            <DataEditor />
          </TabsContent>
        </Tabs>
      </div>
      <div className='flex flex-col gap-2 flex-1'>
        <div className='flex items-center gap-4'>
          <Documentation />
          <Profile />
        </div>
        <LivePreview />
      </div>
    </div>
  );
};
